import React, { Component } from "react";
import { style } from "typestyle";
// @ts-ignore
import Quadcopter from "../../icons/Quadrocopter";
// @ts-ignore
import FixedWings from "../../icons/FixedWings";

type Props = {
  quadcopterIsActive: boolean;
  onClick: (quadcopterIsActive: boolean) => void;
};

export class BufferSwitchControl extends Component<Props> {
  render() {
    return (
      <div
        className={style({
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
        })}
      >
        {this.renderButton(
          this.props.quadcopterIsActive,
          <Quadcopter
            color={this.props.quadcopterIsActive ? "#007AFF" : "#64646E"}
          />,
          "Quadcopter",
          () => this.props.onClick(true),
        )}
        {this.renderButton(
          !this.props.quadcopterIsActive,
          <FixedWings
            color={!this.props.quadcopterIsActive ? "#007AFF" : "#64646E"}
          />,
          "Fixed wing",
          () => this.props.onClick(false),
        )}
      </div>
    );
  }

  renderButton(
    active: boolean,
    icon: JSX.Element,
    title: string,
    onClick: () => void,
  ) {
    return (
      <div
        className={style({
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          padding: "0 16px",
          height: "43px",
          alignItems: "center",
          borderBottom: active ? "2px solid #007AFF" : "2px solid white",
          cursor: "pointer",
        })}
        onClick={onClick}
      >
        {icon}
        <div
          className={style({
            alignItems: "center",
            marginLeft: "15px",
            fontSize: "14px",
            color: active ? "#007AFF" : "#64646E",
          })}
        >
          {title}
        </div>
      </div>
    );
  }
}
